import { render, staticRenderFns } from "./templateSubmittedData.vue?vue&type=template&id=738452d2&scoped=true"
import script from "./templateSubmittedData.vue?vue&type=script&lang=js"
export * from "./templateSubmittedData.vue?vue&type=script&lang=js"
import style0 from "./templateSubmittedData.vue?vue&type=style&index=0&id=738452d2&prod&lang=scss&scoped=true"
import style1 from "./templateSubmittedData.vue?vue&type=style&index=1&id=738452d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738452d2",
  null
  
)

export default component.exports